import {
	InteractionType,
	IPublicClientApplication,
	PublicClientApplication,
} from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { AuthConfig } from './models/auth-config.model';
import { Environment } from '@agilox/common';
import { isInIframe } from './iframe.util';

export function MSALInstanceFactory(config: AuthConfig): IPublicClientApplication {
	const auth: any = {
		clientId: config.msalConfig.clientId,
		authority: config.msalConfig.authority,
		redirectUri: config.msalConfig.redirectUri,
		postLogoutRedirectUri: window.location.origin,
	};
	if (config.msalConfig.knownAuthorities?.length) {
		auth['knownAuthorities'] = config.msalConfig.knownAuthorities;
	}

	return new PublicClientApplication({
		auth,
		cache: {
			cacheLocation: 'localStorage',
			storeAuthStateInCookie: false,
		},
		system: {
			allowNativeBroker: false, // Disables WAM Broker
		},
	});
}

export function MSALInterceptorConfigFactory(config: AuthConfig): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map<string, Array<string>>();

	// Add each API with its specific scopes
	Object.entries(config.msalConfig.apis).forEach(([apiType, apiConfig]) => {
		protectedResourceMap.set(apiConfig.baseUrl, apiConfig.scopes);
	});

	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

export function MSALGuardConfigFactory(config: AuthConfig): MsalGuardConfiguration {
	// Combine all scopes for initial login
	const allScopes = [...Object.values(config.msalConfig.apis).flatMap((api) => api.scopes)];
	const inIframe = isInIframe();

	return {
		interactionType: inIframe ? InteractionType.Popup : InteractionType.Redirect,
		authRequest: {
			scopes: allScopes,
		},
		loginFailedRoute: '/',
	};
}

export function MSALAUTHConfigFactory(env: Environment): AuthConfig {
	return {
		msalConfig: {
			clientId: env.msal.clientId,
			authority: env.msal.authority,
			redirectUri: window.location.origin,
			apis: env.msal.apis,
			knownAuthorities: env.msal.knownAuthorities,
		},
	};
}
